import {
  LayoutDashboard, Receipt, FolderOpen,
  ChevronLeft, ChevronRight, GitCompareArrows, Wrench, PlusCircle, Landmark,
  Bot, Users, UserCheck, Settings, Sparkles, Activity, CreditCard,
} from "lucide-react";

const NAV = [
  { section: "Operação diária" },
  { id: "dashboard",     icon: LayoutDashboard,  label: "Dashboard"      },
  { id: "conciliacao",   icon: GitCompareArrows, label: "Conciliação"    },
  { id: "batches",       icon: CreditCard,       label: "Pagamentos"     },
  { id: "arquivo",       icon: FolderOpen,       label: "Arquivo"        },
  { id: "despesa-rapida", icon: PlusCircle,      label: "Despesa Rápida" },
  { id: "fundos",        icon: Landmark,         label: "Fundos"         },
  { id: "socios",        icon: UserCheck,        label: "Sócios"         },
  { section: "Administração", admin: true },
  { id: "agente",        icon: Bot,              label: "Agente", admin: true },
  { id: "processamento-assistido", icon: Sparkles, label: "Processamento Assistido", admin: true },
  { id: "utilizadores",  icon: Users,            label: "Equipa", admin: true },
  { id: "definicoes",    icon: Settings,         label: "Definições", admin: true },
  { id: "sistema",       icon: Activity,         label: "Sistema", admin: true },
  { id: "manutencao",    icon: Wrench,           label: "Manutenção", admin: true },
];

export function Sidebar({
  active,
  onChange,
  alertCount = 0,
  showAdmin = true,
  collapsed = false,
  onCollapsedChange,
  collapsible = true,
}) {

  return (
    <aside
      className="accounting-sidebar"
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        flexShrink: 0,
        overflow: "hidden",
        background: "#101828",
        borderRight: "1px solid rgba(255,255,255,.06)",
        width: collapsed ? 72 : 252,
        transition: "width 0.3s ease",
      }}
    >
      {/* Logo */}
      <div style={{
        display: "flex", alignItems: "center", gap: 10,
        padding: "0 16px", height: 56, flexShrink: 0,
        borderBottom: "1px solid rgba(255,255,255,.08)",
      }}>
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          width: 36, height: 36, borderRadius: 11, background: "linear-gradient(135deg,#14B8A6,#0F766E)",
          flexShrink: 0,
        }}>
          <Receipt size={17} color="#102d32" strokeWidth={2.4} />
        </div>
        <div style={{
          overflow: "hidden",
          transition: "all 0.3s",
          width: collapsed ? 0 : "auto",
          opacity: collapsed ? 0 : 1,
          whiteSpace: "nowrap",
        }}>
          <p style={{ fontSize: 13.5, fontWeight: 750, color: "#F8FAFC", margin: 0, lineHeight: 1.3 }}>
            Hub Financeiro
          </p>
          <p style={{ fontSize: 10.5, color: "#98A2B3", margin: 0, lineHeight: 1.3 }}>
            Operação contabilística
          </p>
        </div>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: "14px 10px", overflowY: "auto", overflowX: "hidden" }}>
        {NAV.filter((item) => item === null || showAdmin || !item.admin).map((item, i) => {
          if (item?.section) {
            return (
              collapsed
                ? <div key={`section-${i}`} style={{ margin: "12px 10px 8px", borderTop: "1px solid rgba(255,255,255,.08)" }} />
                : <div key={`section-${i}`} style={{ padding: "13px 12px 7px", fontSize: 9.5, fontWeight: 800, letterSpacing: ".11em", textTransform: "uppercase", color: "#667085" }}>{item.section}</div>
            );
          }
          const Icon = item.icon;
          const isActive = active === item.id;
          const showBadge = item.id === "arquivo" && alertCount > 0;

          return (
            <button
              key={item.id}
              onClick={() => onChange(item.id)}
              title={collapsed ? item.label : undefined}
              aria-label={collapsed ? item.label : undefined}
              aria-current={isActive ? "page" : undefined}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                gap: 10,
                padding: collapsed ? "10px 18px" : "9px 12px",
                justifyContent: collapsed ? "center" : "flex-start",
                borderRadius: 10,
                border: "none",
                background: isActive ? "rgba(20,184,166,.16)" : "transparent",
                color: isActive ? "#5EEAD4" : "#CBD5E1",
                fontSize: 13,
                fontWeight: isActive ? 700 : 500,
                cursor: "pointer",
                marginBottom: 2,
                position: "relative",
                transition: "background 0.12s, color 0.12s",
                textAlign: "left",
              }}
              onMouseEnter={e => { if (!isActive) { e.currentTarget.style.background = "rgba(255,255,255,.055)"; e.currentTarget.style.color = "#fff"; } }}
              onMouseLeave={e => { if (!isActive) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#CBD5E1"; } }}
            >
              {/* Active indicator */}
              {isActive && (
                <span style={{
                  position: "absolute", left: 0, top: "20%", bottom: "20%",
                  width: 3, borderRadius: "0 3px 3px 0", background: "#2DD4BF",
                }} />
              )}
              <Icon size={17} style={{ flexShrink: 0, color: isActive ? "#5EEAD4" : "#98A2B3" }} />
              <span style={{
                overflow: "hidden",
                transition: "all 0.3s",
                width: collapsed ? 0 : "auto",
                opacity: collapsed ? 0 : 1,
                whiteSpace: "nowrap",
                flex: collapsed ? undefined : 1,
              }}>
                {item.label}
              </span>
              {!collapsed && showBadge && (
                <span style={{
                  marginLeft: "auto", fontSize: 10, fontWeight: 800,
                  background: "#F79009", color: "#fff",
                  borderRadius: 10, padding: "1px 6px", lineHeight: "normal",
                }}>
                  {alertCount}
                </span>
              )}
              {collapsed && showBadge && (
                <span aria-label={`${alertCount} documentos pendentes`} style={{
                  position: "absolute", top: 6, right: 7, minWidth: 15, height: 15,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  padding: "0 3px", borderRadius: 8, background: "#F79009", color: "#fff",
                  border: "2px solid #101828", fontSize: 8, fontWeight: 800,
                }}>{alertCount > 9 ? "9+" : alertCount}</span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Footer */}
      <div style={{ flexShrink: 0, borderTop: "1px solid rgba(255,255,255,.08)", padding: 8 }}>
        {/* Agent status */}
        <div style={{
          display: "flex", alignItems: "center", gap: 8,
          padding: "8px 12px",
          justifyContent: collapsed ? "center" : "flex-start",
        }}>
          <span style={{ position: "relative", display: "flex", width: 8, height: 8, flexShrink: 0 }}>
            <span style={{
              position: "absolute", inset: 0, borderRadius: "50%",
              background: "#22C55E", opacity: 0.5,
              animation: "sidebar-ping 2s ease-in-out infinite",
            }} />
            <span style={{ position: "relative", width: 8, height: 8, borderRadius: "50%", background: "#16A34A", display: "block" }} />
          </span>
          <span style={{
            fontSize: 11, color: "#98A2B3", whiteSpace: "nowrap",
            overflow: "hidden", transition: "all 0.3s",
            width: collapsed ? 0 : "auto", opacity: collapsed ? 0 : 1,
          }}>
            Agente online
          </span>
        </div>

        {/* Collapse toggle — desktop only; the mobile drawer stays readable. */}
        {collapsible && (
          <button
            onClick={() => onCollapsedChange?.(!collapsed)}
            aria-label={collapsed ? "Expandir menu" : "Recolher menu"}
            aria-expanded={!collapsed}
            title={collapsed ? "Expandir menu" : undefined}
            style={{
              width: "100%", display: "flex", alignItems: "center", gap: 6,
              padding: "8px 12px", borderRadius: 7, border: "none",
              background: "transparent", color: "#98A2B3", fontSize: 12,
              cursor: "pointer", justifyContent: collapsed ? "center" : "flex-start",
            }}
            onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,.055)"; e.currentTarget.style.color = "#fff"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#98A2B3"; }}
          >
            {collapsed ? <ChevronRight size={16} /> : <><ChevronLeft size={14} /><span>Recolher menu</span></>}
          </button>
        )}
      </div>

      <style>{`
        @keyframes sidebar-ping {
          0%, 100% { transform: scale(1); opacity: 0.5; }
          50% { transform: scale(1.8); opacity: 0; }
        }
      `}</style>
    </aside>
  );
}
